var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFailIcon = function SvgFailIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    className: "fail",
    width: 24,
    height: 27,
    viewBox: "0 -2 24 25",
    fill: "#000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6033_1063)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11.8984,
    r: 9,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1.79688C17.53 1.79688 22 6.26687 22 11.7969C22 17.3269 17.53 21.7969 12 21.7969C6.47 21.7969 2 17.3269 2 11.7969C2 6.26687 6.47 1.79688 12 1.79688ZM15.59 6.79688L12 10.3869L8.41 6.79688L7 8.20687L10.59 11.7969L7 15.3869L8.41 16.7969L12 13.2069L15.59 16.7969L17 15.3869L13.41 11.7969L17 8.20687L15.59 6.79688Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6033_1063"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.203125)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFailIcon);
export { ForwardRef as ReactComponent };
export default "/static/media/fail-icon.dda65e57aebe89a7d46c54d261446e7e.svg";